import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getStates = createApiThunk<CountryState[], number>({
  action: 'states',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_COUNTRY_STATES(id),
  responseKey: 'states',
})
